import {  Emitter } from "nanoevents";
import { DataPyaload } from "../interface/payload";
import Resumable  from 'resumablejs';
import { CustomEventOnUploadFileError, CustomEventOnUploadFileSuccess, CustomEventOnUploadProgress } from "../types/customtypes";
import RecorderEventMap from "../interface/RecorderEventMap";

export default class ResumableService{

    private resumable:Resumable;
    private emitter:Emitter<RecorderEventMap>;
    private headers:any;
    constructor(r:Resumable, e :Emitter<RecorderEventMap>,h:any){
          this.resumable=r;
          this.emitter =e;
          this.headers = h;
          }

    public  UploadVideo=async (payload:DataPyaload) :Promise<any|undefined>=>{


        this.resumable.opts.headers  = this.SetPayload(payload)


          var file  = new File([payload.Stream], payload.FileName);


          this.resumable.on('fileAdded',  (file:any, message:any) =>{
            this.resumable.upload();
            return new Promise((s,r)=>{return s(undefined)});
          });

          this.resumable.on('uploadStart', () => {
            this.emitter.emit('AB_Custom_Event_UploadStart');
        });

        this.resumable.on('complete', () => {

            this.emitter.emit('AB_Custom_Event_UploadComplete');
        });


        this.resumable.on('fileSuccess', (file: any, message: any) => {
            var data :CustomEventOnUploadFileSuccess= {
                message:message,
                file:file
            };
            this.emitter.emit('AB_Custom_Event_UploadFileSuccess', data);
        });

        this.resumable.on('error', (file: any, message: any) => {
              var data :CustomEventOnUploadFileError= {
                message:message,
                file:file
            };
            this.emitter.emit('AB_Custom_Event_UploadError', data);
        });


        this.resumable.on('fileProgress', (file:any, message:any) => {
            var percent =  file.progress();
            var data :CustomEventOnUploadProgress= {
            percent:percent
            };
            this.emitter.emit('AB_Custom_Event_UploadProgress', data);
        });

        this.resumable.addFile(file);

    }

    private SetPayload = (payload:DataPyaload)=> {
        return  {
            ...this.headers,
            "X-Abintegro-ProjectName":payload.ProjectName,
            "X-Abintegro-InterviewMaxLength":payload.InterviewMaxLength,
            "X-Abintegro-AustralianHeiOnUkServer":payload.AustralianHeiOnUkServer,

        }
    }
}



